export const en = {
    editorSessionExpired: 'Editor session has expired',
    editorDelete: 'Delete',
    editorEdit: 'Edit',
    editorCancel: 'Cancel',
    editorSubmit: 'Submit',
    editorTemplatesTitle: 'Templates',
    editorTemplatesCreate: 'Create new template',
    editorTemplatesSetNewName: 'New name for format',
    editorTemplatesCreateNew: 'Create new format template',
    editorTemplatesName: 'Format name',
    editorTemplatesWidth: 'Format width [mm]',
    editorTemplatesHeight: 'Format height [mm]',
    editorTemplatesBleed: 'Format bleed [mm]',
    editorTemplatesEditName: 'Edit {formatName} name',
    editorTemplateWarning: 'This format contains projects. Deleting a format means deleting projects. Do you want to continue?',
    editorTemplateRemove: 'Yes, delete format and its projects',
    editorProjectsTitle: 'Templates > Projects',
    editorProjectsCreateNew: 'Create new project',
    editorProjectsName: 'Project name',
    editorProjectsDescription: 'Project description',
    editorProjectsWarning: 'This project contains elements. Deleting a project means deleting elements. Do you want to continue?',
    editorProjectsRemove: 'Yes, delete project and its elements',
    editorProjectEdit: 'Edit project',
    editorPlaceholdersTitle: 'Placeholders',
    editorPlaceholdersName: 'Name',
    editorPlaceholdersSystemName: 'System name',
    editorPlaceholdersAddNew: 'Add new',
    editorPlaceholdersCreateNew: 'Create new',
    editorPlaceholdersUpdate: 'Update placeholder',
    editorPlaceholdersRemove: 'Remove',
    editorTabItemProjects: 'Projects',
    editorTabItemUploads: 'Uploads',
    editorTabItemFrames: 'Frames',
    editorTabItemText: 'Add text',
    editorTabItemShapes: 'Shapes',
    editorTabItemForms: 'Forms',
    editorTabFontTitle: 'Choose a font',
    editorTabTextNewItemContent: 'Doubleclick to edit. Click and drag to move.',
    editorTabShapesTitle: 'Basic shapes',
    editorTabQrTitle: 'Qr Code',
    editorTabQrNewItemContent: 'Qr code text',
    editorTabFrameTitle: 'Click to add an image frame',
    editorTabImagesTitle: 'Uploaded images',
    editorTabImagesUpload: 'Upload image',
    editorTabImagesSetBackground: 'Set as background image',
    editorTabImagesProcessing: 'Processing...',
    editorTabHideFromUser: 'Hide from user',
    editorTabShow: 'Show all',
    editorTabPlaceholdersContent: 'Placeholder content',
    editorTabProjectsBack: 'Back to projects',
    editorTabProjectsWarning: 'Warning!',
    editorTabProjectsOverwrite: 'This layout contains different set of data. Some of your work might be overwritten.',
    editorTabProjectsApplyNewLayout: 'Apply new layout',
    editorTabProjectsHide: 'Hide',
    editorTabProjectsNoLayouts: 'Currently there are no available projects for this format.',
    editorSceneProjectId: 'Project ID:',
    editorScenePriceConfig: 'Product configuration',
    editorScenePriceSummary: 'Summary',
    editorScenePriceNet: 'Price net',
    editorScenePriceVAT: 'Price VAT',
    editorScenePriceTotal: 'Price gross',
    editorSceneElementOptionsAdjustImage: 'Adjust image',
    editorSceneElementOptionsLastUsedColors: 'Last used colors',
    editorSceneElementOptionsWidth: 'Width',
    editorSceneElementOptionsHeight: 'Height',
    editorSceneElementOptionsSize: 'Size',
    editorSceneElementOptionsColors: 'Colors',
    editorSceneElementOptionsSetQRSize: 'Set QR size',
    editorSceneElementOptionsSetQRColor: 'Set QR color',
    editorSceneElementOptionsDelete: 'Delete element',
    editorSceneElementOptionsLock: 'Lock element',
    editorSceneElementOptionsNoPlaceholder: 'No placeholder',
    editorSceneElementOptionsSetPlaceholder: 'Set element placeholder',
    editorSceneElementOptionsSetPosition: 'Set element position',
    editorSceneElementOptionsSetVisibility: 'Show/hide all elements',
    editorSceneElementOptionsPushToFront: 'Push element to front',
    editorSceneElementOptionsPushToBack: 'Push element to back',
    editorSceneElementOptionsFontFamily: 'Pick font family',
    editorSceneElementOptionsFontWeight: 'Pick font weight',
    editorSceneElementOptionsFontSize: 'Pick font size',
    editorSceneElementOptionsTextAlign: 'Align text',
    editorSceneElementOptionsTextCapitalize: 'Capitalize text',
    editorSceneElementOptionsTextUnderline: 'Underline text',
    editorSceneElementOptionsPublishProject: 'Publish project',
    editorSceneElementOptionsPublished: 'Published',
    editorSceneElementOptionsPublish: 'Publish',
    editorSceneElementOptionsSave: 'Save project',
    editorSceneElementOptionsSaveDesign: 'Save design',
    editorSceneElementOptionsSaveAndAdd: ' and add to cart',
    editorSceneElementOptionsValidationErrorMsg: 'Elements have not passed validation. Fix them to save project.',
    editorSceneElementOptionsValidationValue: 'Element value:',
    editorSceneElementOptionsValidationError: 'error:',
    editorScenePageBackgroundSettings: 'Page background settings',
    editorScenePageBackgroundSize: 'Background size',
    editorScenePageBackgroundCustomSize: 'Custom size',
    editorScenePageBackgroundPosition: 'Background position',
    editorScenePageBackgroundRepeat: 'Background repeat',
    editorScenePageBackgroundAdditional: 'Additional options',
    editorScenePageBackgroundRemove: 'Remove background',
    editorScenePageBackgroundColor: 'Background color',
    editorScenePageCornerRadius: 'Page corner rounding',
    editorScenePageNumber: 'Page {num1} of {num2}',
    editorScenePageShowPrevious: 'Show previous page',
    editorScenePageShowNext: 'Show next page',
    editorScenePageSettings: 'Page settings',
    editorScenePageAddNew: 'Add new page',
    editorScenePageDelete: 'Delete page',
    editorScenePageLock: 'Lock page',
    editorScenePageWarning: 'This page contains elements. Do you want to continue?',
    editorScenePageDeleteConfirm: 'Yes, delete page'
}